import { buildRestUrl, buildAuthHeadersForFetch } from "./RestService";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import IUserModel from "../models/IUserModel";
import ISupplierModel from "../models/ISupplierModel";
import IRoute from "../models/IRoute";

const getRoutes = async (userModel: IUserModel, supplierModel: ISupplierModel): Promise<IRoute[]> => {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.GetRoutes });
    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error("Failed to fetch routes");
    }

    const data = await response.json();
    return data.routes || data;
};

const RouteService = {
    getRoutes,
};

export default RouteService;
